var Flickity = require('flickity');

function FeaturedPeople(el) {
	var t = this;

	t.carouselElement = el.querySelector('[data-carousel]');
	t.current = el.querySelector('[data-carousel-current]');
	t.prev = el.querySelector('[data-carousel-prev]');
	t.next = el.querySelector('[data-carousel-next]');

	if (t.carouselElement) {
		t.carousel = new Flickity(t.carouselElement, {
			prevNextButtons: false,
			pageDots: false,
			contain: true,
			adaptiveHeight: false
		});

		if (t.prev) {
			t.prev.addEventListener('click', function() {
				t.carousel.previous();
			});
		}
		if (t.next) {
			t.next.addEventListener('click', function() {
				t.carousel.next();
			});
		}
		if (t.current) {
			t.carousel.on('select', function() {
				t.current.textContent = t.carousel.selectedIndex + 1;
			});
		}
	}
}
module.exports = FeaturedPeople;